import { getCreditReportApi } from "@/global/api/credit";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { creditReportState } from "@/global/store/data/creditReport";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

export function useGetCreditReport() {
  const dispatch = useDispatch();
  const { teamSchema } = useTeamConfig();
  const creditReportReq = useMutation(getCreditReportApi);

  const fetchCreditReport = async () => {
    const payload = { teamSchema };
    await creditReportReq.mutateAsync(payload, {
      onSuccess: ({ data }) => {
        dispatch(creditReportState.actions.set(data));
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  return {
    fetch: fetchCreditReport,
  };
}
